<template>
  <div id="product-documents-ipr-front-jacket-create">

    <front-jacket-form v-model="model" :apiModel="apiModel" ref="form" />

    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
              :disabled="loading"
              @click="$router.push({ name: `${ProductCompanyType}.front-jacket-ipr.list` })"
              class="my-4"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
              :disabled="loading"
              @click="create()"
              class="my-4"
              color="light"
          >
            Upload
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import FrontJacketForm from "@/views/pages/product-documents-ipr/front-jacket/FrontJacketForm";
import ProductDocumentCreateMixin from "@/components/mixins/ProductDocumentCreateMixin";
import IprProductCompanyTypeMixin from "@/components/mixins/IprProductCompanyTypeMixin";

export default {
  name: "FrontJacketIprCreate",
  components: {
    FrontJacketForm,
  },
  mixins: [ProductDocumentCreateMixin, IprProductCompanyTypeMixin],
  data() {
    return {
      apiModel: this.companyTypeApiModel('productFrontJacketIpr'),
    };
  },
};
</script>

<style scoped>

</style>
